<template>
  <div class="nowrap d-flex gap-2">
    <a class="data-table-action"
       :title="$t('receipt')"
       v-b-tooltip.hover
       v-if="object.model"
       @click="printReceipt">
      <PrintSvg/>
      <span class="action-button-mob-title">{{ $t('receipt') }}</span>
    </a>
    <a class="data-table-action"
       :title="$t('akt_print')"
       v-if="object.visit_id"
       v-b-tooltip.hover
       @click="printAkt">
      <NoteSvg/>
      <span class="action-button-mob-title">{{ $t('akt_print') }}</span>
    </a>
    <a class="data-table-action"
       :title="$t('fiscal_cheque_copy_print')"
       v-b-tooltip.hover
       v-if="kkmEnabled && object.check_number"
       @click="fiscalChequePrint">
      <ChequeSvg class="svg-light svg-size-lg"/>
      <span class="action-button-mob-title">{{ $t('fiscal_cheque_copy_print') }}</span>
    </a>
    <a class="data-table-action"
       :title="$t('market_as_fiscal_cheque_manually')"
       v-if="canBeMarkedManually"
       v-b-tooltip.hover
       @click="markAsFiscalChequeManually">
      <TickSvg class="svg-lighter svg-size-lg"/>
      <span class="action-button-mob-title">{{ $t('market_as_fiscal_cheque_manually') }}</span>
    </a>
    <AktOptionsPopup v-if="aktOptionsModalOpen"
                     :default-date="defaultDate"
                     @changed="modalResolve"/>
  </div>
</template>

<script setup>
import PrintSvg from '@/assets/svg-vue/general/print2.svg'
import TickSvg from "@/assets/svg-vue/form/tick.svg.vue"
import NoteSvg from '@/assets/svg-vue/header/note.svg'
import ChequeSvg from '@/assets/svg-vue/patients/cheque.svg'
import JwtService from "@/services/jwt.service"
import {ref, computed, getCurrentInstance, onBeforeMount, nextTick} from "vue"
import {useStore} from "vuex"
import {PatientService} from "@/services/api/patient.api.service"
import AktOptionsPopup from "@/components/parts/patients/AktOptionsPopup.vue"
import moment from "moment/moment"
import KKMService from "@/services/kkm.service"

const store = useStore()

const aktOptionsModalOpen = ref(false)
const modalResolve = ref(null)

let i18n = null
let bvModal = null

const props = defineProps({
  object: {
    type: Object
  }
})

const clinic = computed(() => store.state.auth.clinic)
const rights = computed(() => store.state.auth.rights)
const kkmEnabled = computed(() => store.getters.kkmEnabled)
const canBeMarkedManually = computed(() => {
  return (props.object.fiscal_vendor === 'kkm' || !props.object.fiscal_vendor)
      && rights.value.includes('cashdesk')
      && rights.value.includes('accept_payments')
      && kkmEnabled.value
      && !props.object.fiscal_passed
})

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  i18n = instance?.ctx?.$i18n
  bvModal = instance?.ctx?._bv__modal
})

const printReceipt = () => {
  let link = JwtService.getPrintPrelink(clinic.value)
  if(props.object.model === 'payment') {
    window.open(link+'/receipt/'+props.object.id, '_blank')
  }
  if(props.object.model === 'advance') {
    window.open(link+'/deposit/'+props.object.id, '_blank')
  }
}

const printAkt = async () => {
  const res = await getOptionsForAkt()
  setTimeout(() => {
    aktOptionsModalOpen.value = false
  }, 200)
  let patientSigner = ''
  let signer = res.signer
  const date = res.date
  let link = JwtService.getPrintPrelink(clinic.value)
  window.open(`${link}/akt/${props.object.visit_id}?signer=${signer}&patientSigner=${patientSigner}&date=${date}`, '_blank')
}

const getOptionsForAkt = async () => {
  aktOptionsModalOpen.value = true
  await nextTick()
  bvModal.show('akt-options-popup-modal')
  return new Promise((resolve) => {
    modalResolve.value = resolve
  })
}

const fiscalChequePrint = async () => {
  await KKMService.printChequeCopy(props.object.check_number)
}

const markAsFiscalChequeManually = async () => {
  const chequeId = prompt(i18n.t('enter_the_cheque_number'))
  if(chequeId) {
    try {
      await PatientService.setUUIDForPayment(props.object.id, {
        uuid: chequeId,
        fiscal_vendor: 'kkm',
      })
    } catch (error) {
      console.log(error)
    }
    store.commit('incrementDataTableCounter')
  }
}

const defaultDate = computed(() => {
  if(props.object?.date) {
    return moment(props.object?.date).format('YYYY-MM-DD')
  }
  return null
})
</script>
